import type { ReactNode } from "react";
import { Button } from "../ui/button";

export function ToolbarToggle({ label, pressed, onToggle, children }: {
  label: string;
  pressed: boolean;
  onToggle: (pressed: boolean) => void;
  children: ReactNode;
}) {
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      title={label}
      aria-pressed={pressed}
      className="text-neutral-500 aria-pressed:bg-sky-100 aria-pressed:text-sky-700 aria-pressed:hover:bg-sky-200"
      onClick={() => onToggle(!pressed)}
    >
      {children}
    </Button>
  );
}
